import { DomainEvent, DomainEventType } from '../domain/event';
import { EventBus, EventBusListener, EventBusUnsubscribe } from '../ports/event-bus';

export class DomEventBus implements EventBus {
    emit<E extends DomainEvent<object>>(event: E): void {
        window.dispatchEvent(new CustomEvent(event.type, { detail: event.payload }));
    }
    subscribe<E extends DomainEvent<object>, T extends DomainEventType>(
        type: T,
        listener: EventBusListener<E>
    ): EventBusUnsubscribe {
        const handler = (({ detail }: CustomEvent<E['payload']>) => {
            listener(detail);
        }) as EventListener;

        window.addEventListener(type, handler);

        return () => {
            window.removeEventListener(type, handler);
        };
    }
}
